import { useState } from 'react';
import { useFinancieelStore } from '../../stores';

export function AccountantPakket() {
  const {
    selectedMonth, checklistItems, isSending,
    updateChecklistItem, sendAccountantPakket, bankBestanden, yukiBestand,
  } = useFinancieelStore();

  const [showMailDialog, setShowMailDialog] = useState(false);
  const [email, setEmail] = useState('helenie@wolfsbergenaccountants.nl');

  const completedCount = checklistItems.filter(i => i.is_complete).length;
  const totalCount = checklistItems.length;

  const handleSend = async () => {
    setShowMailDialog(false);
    await sendAccountantPakket(email);
  };

  return (
    <div className="bg-white rounded-card shadow-card p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <h2 className="text-lg font-semibold text-main">Accountant Pakket</h2>
          {totalCount > 0 && (
            <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
              completedCount === totalCount
                ? 'bg-emerald-100 text-emerald-700'
                : 'bg-gray-100 text-gray-600'
            }`}>
              {completedCount}/{totalCount} compleet
            </span>
          )}
        </div>
      </div>

      {checklistItems.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Geen checklist items voor deze maand</p>
      ) : (
        <div className="space-y-2">
          {checklistItems.map(item => {
            const bankFile = bankBestanden.find(b => {
              if (item.item_key === 'bank_cinco') return b.iban.includes('439');
              if (item.item_key === 'bank_botenbaas') return b.iban.includes('670');
              if (item.item_key === 'bank_5sterren') return b.iban.includes('865');
              return false;
            });

            return (
              <div key={item.id} className="flex items-center justify-between py-2 px-3 rounded-lg hover:bg-gray-50">
                <div className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={item.is_complete}
                    onChange={(e) => updateChecklistItem(item.id, e.target.checked)}
                    className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  />
                  <span className={`text-sm ${item.is_complete ? 'text-gray-400 line-through' : 'text-main'}`}>
                    {item.item_label}
                  </span>
                  {item.is_auto && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-700 font-medium">auto</span>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  {item.notes && (
                    <span className="text-xs text-gray-400">{item.notes}</span>
                  )}
                  {item.external_url && (
                    <a
                      href={item.external_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-indigo-600 hover:text-indigo-800"
                    >
                      Open &rarr;
                    </a>
                  )}
                  {bankFile && (
                    <span className="text-xs text-emerald-600">Ge\u00FCpload</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Actions */}
      <div className="mt-4 pt-3 border-t border-gray-100 flex items-center gap-3">
        <button
          onClick={() => setShowMailDialog(true)}
          disabled={isSending || completedCount === 0}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-50 transition-colors"
        >
          {isSending ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              Verzenden...
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Mail naar accountant
            </>
          )}
        </button>
      </div>

      {/* Mail confirmation dialog */}
      {showMailDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md mx-4">
            <h3 className="text-lg font-semibold text-main mb-4">Pakket verzenden</h3>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">E-mailadres</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>

            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-2">Bijlagen die worden meegestuurd:</p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li className="flex items-center gap-1.5">
                  <svg className="w-3.5 h-3.5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  omzet-{selectedMonth}.csv
                </li>
                {bankBestanden.map(b => (
                  <li key={b.id} className="flex items-center gap-1.5">
                    <svg className="w-3.5 h-3.5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    {b.bestand_naam}
                  </li>
                ))}
                {yukiBestand && (
                  <li className="flex items-center gap-1.5">
                    <svg className="w-3.5 h-3.5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    {yukiBestand.bestand_naam} (Yuki XAF)
                  </li>
                )}
              </ul>
            </div>

            <div className="flex items-center justify-end gap-3">
              <button
                onClick={() => setShowMailDialog(false)}
                className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Annuleren
              </button>
              <button
                onClick={handleSend}
                className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700"
              >
                Verzenden
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
